module.exports = __webpack_public_path__ + "img/rowB3.14151e08.png";